'use strict';

import angular from 'angular';
import {UsuariosComponentRoute} from './usuario-route.component.js';
import {CrearUsuarioComponent} from './crear/crear-usuario.component';
import {EditarUsuarioComponent} from './editar/editar-usuario.component';
import UsuarioService from './usuario.service';


/*@ngInject*/
const routes = function routes($routeProvider) {
    $routeProvider
        .when('/usuarios', {
            template: '<usuario-route></usuario-route>',
            authenticate: true,
            administrator: true
        })
        .when('/usuarios/crear', {
            template: '<crear-usuario></crear-usuario>',
            authenticate: true,
            administrator: true
        })
        .when('/usuarios/editar/:id', {
            template: '<editar-usuario usuario="$resolve.usuario.data"></editar-usuario>',
            authenticate: true,
            administrator: true,
            resolve: {
                usuario: getUsuarioPorId
            }
        });
    
    function getUsuarioPorId($route, UsuarioService){
        return UsuarioService.getUsuarioPorId($route.current.params.id);
    }
};

export default angular.module('pizzutoAutopartesApp.usuario', ['pizzutoAutopartesApp.auth', 'ngRoute'])
    .component(UsuariosComponentRoute.selector, UsuariosComponentRoute)
    .component(CrearUsuarioComponent.selector, CrearUsuarioComponent)
    .component(EditarUsuarioComponent.selector, EditarUsuarioComponent)
    .service('UsuarioService', UsuarioService)
    .config(routes)
    .name;



// WEBPACK FOOTER //
// ./client/app/usuario-route/index.js